import dishesApi from '../../api/dishes-api';

const dishes = {
  items: [],
  item: {},
  listSelect: [],
  listAllergens: [],
  listSuggestions: [
    {
      id: '',
      name: 'Sin sugerencias',
    },
    {
      id: 'specialty',
      name: 'Especialidad',
    },
    {
      id: 'recommended',
      name: 'Recomendado',
    },
    {
      id: 'chef_suggestion',
      name: 'Sugerencia del chef',
    },
  ],
  listCategoriesDishes: [],
  popupNewDish: false,
  popupEditDish: false,
  createdCorrect: false,
};

const mutations = {
  setItemsDishes(state, payload) {
    state.items = payload.data;
  },
  setItemDish(state, payload) {
    state.item = payload;
  },
  setSelectDishes(state, payload) {
    state.listSelect = payload.data;
  },
  setListCategoriesDishes(state, payload) {
    state.listCategoriesDishes = payload.data;
  },
  setListAllergens(state, payload) {
    state.listAllergens = payload.data;
  },
  setpopupNewDish(state, payload) {
    state.popupNewDish = payload;
  },
  setpopupEditDish(state, payload) {
    state.popupEditDish = payload;
  },
  setCreatedCorrect(state, payload) {
    state.createdCorrect = payload;
  },
};

const actions = {
  async refreshDishes(context, { language, restaurant_id }) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    if (restaurant_id) {
      context.commit('loading', true);
      const res = await dishesApi.getAllByRestaurant(restaurant_id, language);
      context.commit('loading', false);
      context.commit('setItemsDishes', res.data);
    }
  },
  async getDish(context, { id, language, isEditDish }) {
    if (!isEditDish) context.commit('loading', true);
    context.commit('setItemDish', {});
    dishesApi.getOne(id, language).then(
      (response) => {
        context.commit('setItemDish', response.data.data);
        if (!isEditDish) context.commit('loading', false);
      },
      (error) => {
        context.commit('loading', false);
      }
    );
  },
  async getDishPublic(context, { dishId, slug, language }) {
    context.commit('loading', true);
    context.commit('setItemDish', {});
    dishesApi.getOnePublic(dishId, slug, language).then(
      (response) => {
        context.commit('setItemDish', response.data.data);
        context.commit('loading', false);
      },
      (error) => {
        context.commit('loading', false);
      }
    );
  },
  async getAllCategoriesDishes(context, { language }) {
    const res = await dishesApi.getCategoriesDishes(language);
    context.commit('setListCategoriesDishes', res);
  },
  async getAllAllergens(context, { language }) {
    const res = await dishesApi.getAllergens(language);
    context.commit('setListAllergens', res);
  },
  createDish({ commit, dispatch }, { dish, language }) {
    commit('loading', true);
    dishesApi.create(dish, language).then(
      (response) => {
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('notifications', { title: 'product.ProductoCreado' });
        commit('setpopupNewDish', false);
        commit('loading', false);
        commit('showNotifications', true);
        commit('setCreatedCorrect', true);
      },
      (error) => {
        commit('loading', false);
        commit('notifications', {
          title: 'product.NotProductoCreado',
          color: 'danger',
        });
        commit('showNotifications', true);
      }
    );
  },
  deleteDish({ commit, dispatch }, id) {
    commit('loading', true);
    dishesApi.delete(id).then(
      (response) => {
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('notifications', { title: 'product.ProductoEliminado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', {
          title: 'product.NotProductoEliminado',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  activeDish({ commit, dispatch }, id) {
    commit('loading', true);
    dishesApi.active(id).then(
      (response) => {
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('notifications', { title: 'product.ProductoActivado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', {
          title: 'product.NotProductoActivado',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  deactiveDish({ commit, dispatch }, id) {
    commit('loading', true);
    dishesApi.deactive(id).then(
      (response) => {
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('notifications', { title: 'product.ProductoDesactivado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        if (error.response.status === 409) {
          let listMessages = [];
          Object.entries(error.response.data.message).forEach(
            ([key, value]) => {
              listMessages.push(value.name);
            }
          );
          listMessages.forEach((message) => {
            commit('notifications', {
              title: '',
              text: message,
              color: 'warning',
            });
          });

          commit('notifications', {
            title: 'Hay que quitar el producto de estos menús:',
            color: 'warning',
          });
        } else {
          commit('notifications', {
            title: 'product.NotProductoDesactivado',
            color: 'danger',
          });
        }
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  editDish({ commit, dispatch }, { id, dish, language }) {
    commit('loading', true);
    dishesApi.edit(id, dish, language).then(
      () => {
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('notifications', { title: 'product.ProductoEditado' });
        commit('loading', false);
        commit('setpopupEditDish', false);
        commit('showNotifications', true);
      },
      () => {
        commit('notifications', {
          title: 'product.NotProductoEditado',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  editDishChangeLanguage(
    { commit, dispatch },
    { id, dish, language, newLanguage }
  ) {
    commit('loading', true);
    dishesApi.edit(id, dish, language).then(
      (response) => {
        commit('setpopupEditDish', false);
        dispatch('refreshDishes', {
          language: this.getters.getCurrentLanguage,
        });
        commit('loading', false);
        commit('setpopupEditDish', true);
      },
      // eslint-disable-next-line sonarjs/no-identical-functions
      (error) => {
        commit('notifications', {
          title: 'product.NotProductoEditado',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  addOrUpdateDishHours({ commit }, { id, hours, newLanguage }) {
    dishesApi.addOrUpdateDishHours(id, hours, newLanguage).then(
      () => {
        commit('notifications', { title: 'product.AgregarHorarioProducto' });
        commit('showNotifications', true);
      },
      () => {
        commit('notifications', {
          title: 'product.NotAgregarHorarioProducto',
          color: 'danger',
        });
        commit('showNotifications', true);
      }
    );
  },
};

const getters = {
  getDish: (state) => state.item,
  getDishes: (state) => state.items,
  getSuggestionsDishesList: (state) => state.listSuggestions,
  getCategoriesDishesList: (state) => state.listCategoriesDishes,
  getAllergens: (state) => state.listAllergens,
  getpopupNewDish: (state) => state.popupNewDish,
  getpopupEditDish: (state) => state.popupEditDish,
  getCreatedCorrect: (state) => state.createdCorrect,
};

export default {
  state: dishes,
  mutations,
  actions,
  getters,
};
